import { NARAConsole } from './components/NARAConsole';

export default function App() {
  return <NARAConsole />;
}
